import { CardContent, Grid, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import SimpleCard from '../../../../../components/SimpleCard';
import SpaceDimensionsCheckBoxes from './SpaceDimensionsCheckBoxes';

// eslint-disable-next-line react/prop-types
export default function SpaceDimensions({ selectedSpaceDimension, handleChangeCheckBoxes }) {
  const { event } = useSelector((store) => store.events);

  const totalPrice = 0;
  return (
    <SimpleCard variant="outlined">
      <CardContent>
        <Grid container marginBottom={2}>
          <Grid item>
            <Typography fontWeight="bold">Space Dimension:</Typography>
          </Grid>
        </Grid>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={8}>
            <SpaceDimensionsCheckBoxes
              spaceDimensions={event?.space_dimensions}
              handleChange={handleChangeCheckBoxes}
              selectedSpaceDimension={selectedSpaceDimension}
            />
          </Grid>
        </Grid>
      </CardContent>
    </SimpleCard>
  );
}
